<form [formGroup]="templatesAndMessagesFG" class="grid grid-cols-2 gap-4 p-4">

  <!-- HTML Templates -->
  <div class="col-span-2">
    <h2 class="text-lg font-semibold mb-2">{{'HTML-templates' | translate}}</h2>
  </div>

  <mat-form-field appearance="outline">
    <mat-label>{{'Message-type' | translate}}</mat-label>
    <mat-select formControlName="selectedTypeHTML" (selectionChange)="selectTemplateHTML()" [disabled]="true">
      <mat-option *ngFor="let type of getUniqueTypesHTML()" [value]="type">
        {{type | translate}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>{{'Template-language' | translate}}</mat-label>
    <mat-select formControlName="selectedLangHTML" (selectionChange)="selectTemplateHTML()">
      <mat-option *ngFor="let lang of getUniqueLangsHTML()" [value]="lang">
        {{lang | translate}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="col-span-2">
    <mat-label>{{'HTML-template' | translate}}</mat-label>
    <textarea matInput formControlName="textareaValueHTML" rows="8"></textarea>
  </mat-form-field>

  <!-- SMS Templates -->
  <div class="col-span-2 mt-6">
    <h2 class="text-lg font-semibold mb-2">{{'SMS-templates' | translate}}</h2>
  </div>

  <mat-form-field appearance="outline">
    <mat-label>{{'SMS-sender-name' | translate}}</mat-label>
    <input matInput formControlName="smsAccountName">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>{{'Message-type' | translate}}</mat-label>
    <mat-select formControlName="selectedTypeSMS" (selectionChange)="selectTemplateSMS()" [disabled]="true">
      <mat-option *ngFor="let type of getUniqueTypesSMS()" [value]="type">
        {{type | translate}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>{{'Template-language' | translate}}</mat-label>
    <mat-select formControlName="selectedLangSMS" (selectionChange)="selectTemplateSMS()">
      <mat-option *ngFor="let lang of getUniqueLangsSMS()" [value]="lang">
        {{lang | translate}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="col-span-2">
    <mat-label>{{'SMS-default-message' | translate}}</mat-label>
    <textarea matInput formControlName="textareaValueSMS" rows="8"></textarea>
  </mat-form-field>

</form>